import PropTypes from 'prop-types';
import classNames from 'classnames';

import { useModalContext } from '../providers';

export function ModalDialog(
  {
    title,
    size,
    className,
    classContent,
    classHeader,
    children,
    useCloseModal = false,
    useBackdropClose = false
  }
) {
  const { closeModal } = useModalContext();
  return (
    <div
      className="modal fade show d-block"
      tabIndex="-1"
      aria-modal="true"
      role="dialog"
      {...useBackdropClose && ({
        onClick: () => closeModal({ fromModal: true }),
        role: 'button'
      })}
    >
      <div
        className={classNames('modal-dialog', className, size && `modal-${size}`)}
        {...useBackdropClose && ({
          onClick: (event) => event.stopPropagation()
        })}
      >
        <div className={classNames('modal-content', classContent)}>
          {title && (
            <div className={classNames('modal-header', classHeader)}>
              <div className="modal-title" style={{ width: useCloseModal ? '95%' : '100%' }}>
                {title}
              </div>
              {useCloseModal && (
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={() => closeModal({ fromModal: true })}
                />
              )}
            </div>
          )}
          {children}
        </div>
      </div>
    </div>
  );
}

ModalDialog.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node, PropTypes.object]),
  size: PropTypes.oneOf(['xl', 'lg', 'sm', 'md']),
  className: PropTypes.string,
  classContent: PropTypes.string,
  classHeader: PropTypes.string,
  children: PropTypes.node.isRequired,
  useCloseModal: PropTypes.bool,
  useBackdropClose: PropTypes.bool
};

export default ModalDialog;
